export default [
  {
    path: "/login",
    name: "login",
    hidden: true,
    // component: () => import(/* webpackChunkName: "detail" */ "@/views/detail/Basic.vue"),
    // webpackChunkName命名相同的会打在一起
    component: () => import("@/views/Login/Login.vue"),
    meta: {
      title: "登录",
    },
  },
  {
    path: "/fullScreen",
    name: "fullScreen",
    hidden: true,
    // component: () => import(/* webpackChunkName: "detail" */ "@/views/detail/Basic.vue"),
    // webpackChunkName命名相同的会打在一起
    component: () => import("@/views/FullScreen/index.vue"),
    meta: {
      title: "宿舍大屏",
    },
  },
];
